module.exports = __webpack_public_path__ + "img/57.4.NH3-N.64afc108.png";